import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  message,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import CompanyServices from "../../services/CompanyServices";
import { translate } from "../../locale";
import TextArea from "antd/lib/input/TextArea";
import PickVademecum from "../PickVademecum";

const AddCompany = ({ visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    name: "",
    terms: "",
    vademecum: [],
  });
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const [listOfVademecum, setListOfVademecum] = useState([]);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
    }
  }, [visible]);

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("Todos los datos son requeridos");
      return;
    }
    try {
      const data = {
        name: values.name,
        terms_conditions: values.terms,
        vademecums: values.vademecum,
      };
      const res = await CompanyServices.updateCompany(data);
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          message.success(
            "La {0} se guardó exitosamente.",
            translate("empresa")
          );
        } else if (res.data.detail) {
          message.error(res.data.detail, 6);
        } else {
          message.success(res.data.message, 6);
        }
        resetForm();
        setLoading(false);
        if (onComplete) {
          onComplete();
        }
      } else {
        setError("Add company error");
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      name: "",
      terms: "",
      vademecum: [],
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleAddVademecum = (id) => {
    setValues((prevValues) => {
      const isSelected = prevValues.vademecum.includes(id);
      const newVademecum = isSelected
        ? prevValues.vademecum.filter((vid) => vid !== id)
        : [...prevValues.vademecum, id];

      return { ...prevValues, vademecum: newVademecum };
    });
  };

  return (
    <Modal
      open={active}
      title={translate("Agregar Empresa")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="w-full"
      >
        <Form.Item>
          <Input
            placeholder="Nombre"
            className="border-custom_primary"
            name="name"
            onChange={(e) => handleChange("name", e.target.value)}
            onBlur={handleBlur}
            value={values.name}
          />
          {simpleValidator.current.message("name", values.name, "required")}
        </Form.Item>

        <Form.Item>
          <TextArea
            placeholder="Términos y condiciones"
            className="border-custom_primary"
            name="terms"
            onChange={(e) => handleChange("terms", e.target.value)}
            onBlur={handleBlur}
            value={values.terms}
          />
          {simpleValidator.current.message("terms", values.terms, "required")}
        </Form.Item>
        <Form.Item>
          <PickVademecum
            onClickVademecum={handleAddVademecum}
            values={values}
          />
        </Form.Item>
        <Form.Item>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                {translate("Cancelar")}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
              >
                {loading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ color: "#666666" }} />}
                  />
                ) : (
                  "Agregar"
                )}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCompany;
